import { LeaveRecsQuery } from './leaves.model';
import { LeaveActionTypes, LeaveState } from './leaves.types';

const initialState: LeaveState = {
  leaveRecords: [],
  listLoading: false,
  totalCount: 0,
  lastQuery: new LeaveRecsQuery(),
  selectedLeave: null,
  leaveTypes: [],
  actionLoading: false,
};

export const leaveReducer = (
  state = initialState,
  { type, payload }: { type: string; payload: any }
): LeaveState => {
  switch (type) {
    case LeaveActionTypes.LeavePageToggleLoading: {
      return { ...state, listLoading: payload.isLoading };
    }
    case LeaveActionTypes.LeavePageLoaded: {
      return {
        ...state,
        leaveRecords: payload.leaveRecords,
        totalCount: payload.totalCount,
        listLoading: false,
        lastQuery: { ...state.lastQuery, ...payload.query },
      };
    }
    // New reducer cases
    case LeaveActionTypes.LeaveActionToggleLoading: {
      return { ...state, actionLoading: payload.isLoading };
    }
    case LeaveActionTypes.LeaveDetailLoaded: {
      return { ...state, selectedLeave: payload.leaveDetail };
    }
    case LeaveActionTypes.LeaveApplySuccess:
    case LeaveActionTypes.LeaveUpdateSuccess:
    case LeaveActionTypes.LeaveDeleteSuccess: {
      return { ...state, actionLoading: false };
    }
    case LeaveActionTypes.LeaveTypesLoaded: {
      return { ...state, leaveTypes: payload.leaveTypes };
    }
    default:
      return state;
  }
};

export const selectedLeaveSelector = (state: { leaves: LeaveState }) => state.leaves.selectedLeave;
export const leaveTypesSelector = (state: { leaves: LeaveState }) => state.leaves.leaveTypes;
export const actionLoadingSelector = (state: { leaves: LeaveState }) => state.leaves.actionLoading;
